import * as Yup from 'yup';
import { useMemo } from 'react';

export const SeoPageSchema = (currentSeoPage: any) => {
  const NewSeoPageSchema = Yup.object().shape({
    title: Yup.string().min(3).required('Title is required'),
    title_ar: Yup.string().min(3).required('Title_ar is required'),
    description: Yup.string().notRequired(),
    description_ar: Yup.string().notRequired(),
    keywords: Yup.array().notRequired(),
    keywords_ar: Yup.array().notRequired(),
  });
  const defaultValues: any = useMemo(
    () => ({
      title: currentSeoPage?.title || '',
      title_ar: currentSeoPage?.title_ar || '',
      description: currentSeoPage?.description || '',
      description_ar: currentSeoPage?.description_ar || '',
      keywords: currentSeoPage?.keywords || [],
      keywords_ar: currentSeoPage?.keywords_ar || [],
    }),
    [currentSeoPage]
  );

  return { NewSeoPageSchema, defaultValues };
};
